// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2pfl8","tab":"ProcedureTabs_tab__2oXGj"};